module.exports = __webpack_public_path__ + "static/img/performanceplanner2.30a1e7b2.png";